import { createFeatureSelector, createSelector } from '@ngrx/store';

const getPortalState = createFeatureSelector('PORTAL_STORE');

export const getShelterDataSlice = createSelector(
  getPortalState,
  (state: any) => state.shelterData,
);

export const getShelterDataLoaded = createSelector(
  getShelterDataSlice,
  (state: any) => state.loaded,
);

export const getShelterDataLoading = createSelector(
  getShelterDataSlice,
  (state: any) => state.loading,
);

export const getShelterDataShelterId = createSelector(
  getShelterDataSlice,
  (state: any) => state.shelterId,
);

export const getShelterDataColumnDefs = createSelector(
  getShelterDataSlice,
  (state: any) => state.columnDefs,
);

export const getShelterDataRowData = createSelector(
  getShelterDataSlice,
  (state: any) => state.rowData,
);
